import React from 'react'
import { Icon } from '@material-ui/core'
import { FormattedMessage } from 'react-intl'
import { Routes } from 'app/services/routeService/routeService'

const PanelTitle = (props) => {
  const { history } = props

  const onGoBack = () => {
    history.push(Routes.subscribersV4())
  }
  return (
    <div className="flex text-18 text-primary">
      <div className="opacity-50 cursor-pointer" onClick={onGoBack}>
        <FormattedMessage id="navigation.directory.subscribers.label" />
      </div>
      <div className="px-5">
        <Icon className="text-12 font-bold" color="action">
          arrow_forward_ios
        </Icon>
      </div>
      <div>
        <FormattedMessage id="text.details" />
      </div>
    </div>
  )
}

export default PanelTitle
